import React from 'react';

interface Props {
    address: string;
    allowEdit: boolean;
    onEditClick: React.MouseEventHandler<Element>;
}

const AddressLabel = (props: Props) => {
    return (
        <div className="display-flex align-items-baseline">
            <span className="font-6 font-sans font-400 mar-t-1 line-height-13 text-truncate">{props.address}</span>
            {props.allowEdit ? (
                <span className="fa fa-pencil-square-o c-blue font-5 mar-l-3" onClick={props.onEditClick}></span>
            ) : null}
        </div>
    );
};

export default AddressLabel;
